<main class="principal" id="principal">
  <section id="banner" class="banner">
    <img
      src="/assets/comprimidas/{{ catalogo?.imagem }}"
      alt="{{ catalogo?.nome }}"
      class="banner"
    />

    <div class="text-container container">
      <h1 class="home-title color-dark" *ngIf="catalogo">
        O que é o Catálogo Nacional de Cursos Técnicos?
      </h1>
      <p
        class="paragraph color-dark"
        [innerHTML]="catalogo?.apresentacao | primeiroParagrafo | textToLink"
      ></p>
    </div>
  </section>
  <app-carrousel [eixos]="eixos"></app-carrousel>
</main>
